export default {
	id: 'SIMPLE_PREMIUM_1M_35_1M_8_99',
	providers: {
		paltaMap: {
			EUR: 'simple_premium_1m_35_1m_8_99_eur',
		},
		primer: 'prd_Ef2DeQDWNAnu',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'month',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 30,
		priceMap: {
			EUR: 8.99,
		},
		originalPriceMap: {
			EUR: 35,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			EUR: 35,
		},
	},
	options: ($t) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.30_days.into_period_text'), // 'first month'
		explicitTermsIntervalText: $t('pages.program.organic.cheap_and_short.plans.30_days.sub_period_text'), // 'monthly'
		billingSubtitlePeriodText: $t('pages.program.cheap_and_short.plans.30_days.into_period_text'), // 'first month'
		footerPeriodText: $t('pages.program.cheap_and_short.plans.30_days.period_text'), // '1-month'
		footerIntervalText: $t('pages.program.cheap_and_short.plans.30_days.sub_period_text'), // 'monthly'
	}),
}
